import type { FilterSection } from "@/types/filter";
import jobTypesFilterOptions from "@/utils/constants/jobTypesFilterOptions";
// import monthsFilterOption from "@/utils/constants/monthsFilterOption";
// import yearsFilterOption from "@/utils/constants/yearsFilterOption";

const FILTER_SECTIONS: FilterSection[] = [
  {
    key: 'jobType',
    label: 'Job Type',
    type: 'select',
    options: jobTypesFilterOptions,
  },
  {
    key: 'jobLocation',
    label: 'Job Location',
    type: 'text',
    placeholder: 'Enter job location',
  },
  {
    key: 'searchBy',
    label: 'Search By',
    type: 'text',
    placeholder: 'Enter search term',
  },
  {
    key: 'isExpired',
    label: 'Is Expired?',
    type: 'boolean',
  }
  // {
  //   key: 'year',
  //   label: 'Year',
  //   type: 'select',
  //   options: yearsFilterOption,
  // },
  // {
  //   key: 'month',
  //   label: 'Month',
  //   type: 'select',
  //   options: monthsFilterOption,
  // },
];

export default FILTER_SECTIONS;